import { createSlice } from '@reduxjs/toolkit';

export const initState = {
    keyword: '',
    searchOption: '',
    manipulationType: '',
};

const { actions, reducer } = createSlice({
    name: 'iotItemInfoLog',
    initState,
    reducers: {
        setKeyword: (state, action) => {
            state.keyword = action.payload;
        },
        setSearchOption: (state, action) => {
            state.searchOption = action.payload;
        },
        setManipulationType: (state, action) => {
            state.manipulationType = action.payload;
        },
        reset: (state, action) => {
            const initialState = { ...initState, ...action.payload };
            for (let key in initialState) {
                state[key] = initialState[key];
            }
        },
    },
});

export const { setKeyword, setSearchOption, setManipulationType, reset } = actions;
export default reducer;
